import { useDispatch, useSelector } from 'react-redux'
import { caseActions } from '../../../../../store/case'
import { caseQuickUpdate } from '../../../../../lib/fetchApi'
import { notificationActions } from '../../../../../store/notifications'
import { formatDate } from '../../../../../lib/script'
import PreoperativeTests from '../surgicalTab/PreoperativeTests'
import SurgicalTab7 from '../surgicalTab/SurgicalTab7'

import classes from '../SurgicalDrawer.module.css'

export default function SurgicalDrawer3({itemData, apiCase}) {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const updateHandler = async (data) => {
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }

        let dispatchBody = {
            folder: data.identifier.folder,
            item: {
                itemId: itemData.id,
                fields: [
                    {
                        field: data.identifier.field,
                        value: data.data.value
                    }
                ]  
            },
        }



        if (data.identifier.extra && data.identifier.extra== 'date') {
            let today = formatDate(new Date())
            // reqBody.fields[data.identifier.field + '_obtained_date'] = data.data.value ? today : null
            reqBody.fields[data.identifier.field + '_date'] = data.data.value ? today : null

            dispatchBody.item.fields.push({
                field: data.identifier.field + '_date',
                value: data.data.value ? today : null
            })
        }

        if (data.identifier.clear_data) {
            reqBody.fields[data.identifier.field + '_obtained_date'] = null
            reqBody.fields[data.identifier.field + '_obtained'] = 0
            reqBody.fields[data.identifier.field + '_requested_date'] = null
            reqBody.fields[data.identifier.field + '_requested'] = 0

            let dispatchExtra = [
                {
                    field: data.identifier.field + '_obtained_date',
                    value: null
                },
                {
                    field: data.identifier.field + '_obtained',
                    value: 0
                },
                {
                    field: data.identifier.field + '_requested_date',
                    value: null
                },
                {
                    field: data.identifier.field + '_requested',
                    value: 0
                }
            ]

            dispatchBody.item.fields.push(...dispatchExtra)
        }

        setTimeout(() => {
            dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
        }, 0)

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        }   
        
        
        
    }


    return <div className={`${classes.drawer_container} ${classes.drawer_container_2}`}>
        
        <PreoperativeTests itemData={itemData} updateHandler={updateHandler} apiCase={apiCase}/>

        <SurgicalTab7 classes={classes} updateHandler={updateHandler} itemData={itemData} apiCase={apiCase} activeCase={activeCase}/>
    </div>
}